'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { AlertTriangle, UserX, FlaskConical, ShieldAlert, ArrowRight } from 'lucide-react';
import { printJobService } from '@/lib/supabaseService';
import { PrintJob } from '@/lib/mockData';

export default function DashboardAlerts() {
  const [incomplete, setIncomplete] = useState<PrintJob[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    printJobService.getIncomplete().then((data) => {
      setIncomplete(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="rounded-xl border" style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}>
      <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: 'var(--border)' }}>
        <div className="flex items-center gap-2">
          <AlertTriangle size={16} style={{ color: 'var(--warning)' }} />
          <h3 className="text-sm font-600" style={{ color: 'var(--foreground)' }}>Impressions incomplètes</h3>
          {!loading && (
            <span className="status-badge" style={{ backgroundColor: 'rgba(245, 158, 11, 0.15)', color: 'var(--warning)' }}>
              {incomplete?.length}
            </span>
          )}
        </div>
        <Link href="/print-jobs-list" className="flex items-center gap-1 text-xs transition-colors hover:opacity-80" style={{ color: 'var(--primary)' }}>
          Voir tout <ArrowRight size={12} />
        </Link>
      </div>
      <div className="divide-y" style={{ borderColor: 'var(--border)' }}>
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <div key={`alert-skel-${i}`} className="px-5 py-3 animate-pulse">
              <div className="h-3 rounded w-3/4 mb-2" style={{ backgroundColor: 'var(--muted)' }} />
              <div className="h-2 rounded w-1/2" style={{ backgroundColor: 'var(--muted)' }} />
            </div>
          ))
        ) : incomplete?.length === 0 ? (
          <div className="px-5 py-8 text-center">
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Toutes les impressions sont complètes ✓</p>
          </div>
        ) : (
          incomplete?.map((job) => (
            <div key={`alert-${job?.id}`} className="flex items-center justify-between px-5 py-3 table-row-hover">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate" style={{ color: 'var(--foreground)' }}>
                  {job?.file_name?.replace('.slp3', '')}
                </p>
                <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
                  {job?.printed_at ? new Date(job.printed_at)?.toLocaleDateString('fr-FR') : '—'} · {job?.material_type}
                </p>
              </div>
              <div className="flex items-center gap-1.5 ml-4 flex-shrink-0">
                {!job?.patient_id && (
                  <span className="flex items-center gap-1 text-2xs px-1.5 py-0.5 rounded" style={{ backgroundColor: 'rgba(245, 158, 11, 0.12)', color: 'var(--warning)' }}>
                    <UserX size={10} /> Patient
                  </span>
                )}
                {!job?.resin_lot_id && (
                  <span className="flex items-center gap-1 text-2xs px-1.5 py-0.5 rounded" style={{ backgroundColor: 'rgba(6, 182, 212, 0.12)', color: 'var(--accent)' }}>
                    <FlaskConical size={10} /> Lot
                  </span>
                )}
                {job?.qc_status === 'pending' && (
                  <span className="flex items-center gap-1 text-2xs px-1.5 py-0.5 rounded" style={{ backgroundColor: 'rgba(239, 68, 68, 0.12)', color: 'var(--danger)' }}>
                    <ShieldAlert size={10} /> Validation
                  </span>
                )}
                <Link href={`/print-job-detail?id=${job?.id}`} className="ml-2 text-xs px-2 py-1 rounded transition-colors hover:opacity-80" style={{ backgroundColor: 'rgba(14, 165, 233, 0.1)', color: 'var(--primary)' }}>
                  Compléter
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}